import { FC, useEffect } from "react";

import { Alert, Button, Form, Input, Select } from "antd";
import { useForm } from "antd/lib/form/Form";

import styles from "./StandSettings.module.scss";

import { spBaudRates, spDataBits, spParities, spStopBits } from "@/root/consts";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { IStandSettings } from "@/models/StandSettings";
import { editSettings } from "@/store/reducers/settings/asyncActionCreators";

const { Option } = Select;

const StandSettings: FC = () => {
  const dispatch = useAppDispatch();

  const [form] = useForm();
  const { standSettings, editSettingsLoading, editSettingsError  } =
    useAppSelector((state) => state.settingsReducer);
  const isConnected = useAppSelector(
    (state) =>
      state.serverReducer.serverConnected
  );
  
  useEffect(() => {
    if (standSettings) {
      form.setFieldsValue(standSettings);
    }
  }, [standSettings, form]);

  const handleFinish = (values: IStandSettings) => {
    dispatch(editSettings(values));
  };

  return (
    <Form
      className={styles.form}
      form={form}
      hideRequiredMark
      disabled={!standSettings || !isConnected}
      name="stand"
      onFinish={handleFinish}
    >
      <Form.Item
        label="Serial port path"
        name="sp_path"
        rules={[
          {
            required: true,
            message: "Please input the serial port path",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Serial port baud rate"
        name="sp_baudrate"
        rules={[
          {
            required: true,
            message: "Please select the serial port baud rate",
          },
        ]}
      >
        <Select placeholder="Select an option" allowClear>
          {spBaudRates.map((rate) => (
            <Option key={rate} value={rate}>
              {rate}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Serial port data bits"
        name="sp_databits"
        rules={[
          {
            required: true,
            message: "Please select the serial port  data bits",
          },
        ]}
      >
        <Select placeholder="Select an option" allowClear>
          {spDataBits.map((bit) => (
            <Option key={bit} value={bit}>
              {bit}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Serial port parity"
        name="sp_parity"
        rules={[
          {
            required: true,
            message: "Please select the serial port parity",
          },
        ]}
      >
        <Select placeholder="Select an option" allowClear>
          {spParities.map((parity) => (
            <Option key={parity} value={parity}>
              {parity}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Serial port stop bits"
        name="sp_stopbits"
        rules={[
          {
            required: true,
            message: "Please select the serial port stop bits",
          },
        ]}
      >
        <Select placeholder="Select an option" allowClear>
          {spStopBits.map((bit) => (
            <Option key={bit} value={bit}>
              {bit}
            </Option>
          ))}
        </Select>
      </Form.Item>
      {/*<Form.Item*/}
      {/*  label="Serial port timeout (ms)"*/}
      {/*  name="sp_timeout"*/}
      {/*  rules={[*/}
      {/*    {*/}
      {/*      required: true,*/}
      {/*      message: "Please input the serial port timeout",*/}
      {/*    },*/}
      {/*  ]}*/}
      {/*>*/}
      {/*  <Input type="number" />*/}
      {/*</Form.Item>*/}
      {/*<Form.Item*/}
      {/*  label="PLC form"*/}
      {/*  name="plc_form"*/}
      {/*  rules={[*/}
      {/*    {*/}
      {/*      required: true,*/}
      {/*      message: "Please input the PLC form",*/}
      {/*    },*/}
      {/*  ]}*/}
      {/*>*/}
      {/*  <Input type="number" />*/}
      {/*</Form.Item>*/}
      <Form.Item
        label="PLC station"
        name="plc_station"
        rules={[
          {
            required: true,
            message: "Please input the PLC station",
          },
        ]}
      >
        <Input type="number" />
      </Form.Item>
      {/*<Form.Item*/}
      {/*  label="PLC read interval (ms)"*/}
      {/*  name="plc_readinterval"*/}
      {/*  rules={[*/}
      {/*    {*/}
      {/*      required: true,*/}
      {/*      message: "Please input the PLC read interval",*/}
      {/*    },*/}
      {/*  ]}*/}
      {/*>*/}
      {/*  <Input type="number" />*/}
      {/*</Form.Item>*/}

      {editSettingsError && (
        <Form.Item>
          <Alert type="error" message={editSettingsError} />
        </Form.Item>
      )}

      <Form.Item>
        <Button
          htmlType="submit"
          type="primary"
          loading={editSettingsLoading}
          disabled={editSettingsLoading}
        >
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default StandSettings;
